/** @jsxImportSource @emotion/react */
'use client';

import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { Button } from './Button';
import type { BackButtonProps, PaginationButtonProps } from './types';
import { defaultIconProps } from '../Icon';

export const BackButton = React.forwardRef<HTMLButtonElement, BackButtonProps>(
  ({ children, label = 'Back', testId = 'back-button', ...rest }, ref) => {
    return (
      <Button
        ref={ref}
        variant="ghost"
        leftIcon={<ChevronLeft {...defaultIconProps} size={16} />}
        testId={testId}
        {...rest}
      >
        {children ?? label}
      </Button>
    );
  }
);

BackButton.displayName = 'BackButton';

export const PaginationButton = React.forwardRef<
  HTMLButtonElement,
  PaginationButtonProps
>(({ active = false, children, testId = 'pagination-button', ...rest }, ref) => {
  return (
    <Button
      ref={ref}
      variant="chip"
      active={active}
      testId={testId}
      {...rest}
      aria-current={active ? 'page' : undefined}
      aria-pressed={undefined}
    >
      {children}
    </Button>
  );
});

PaginationButton.displayName = 'PaginationButton';
